"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = require("@headlessui/react");
const constants_1 = require("../../constants");
const Icon_1 = require("../Icon");
const IconPlaceholder = styled_1.default.div({
    height: 16,
    width: 16,
});
const Item = (0, styled_1.default)(react_1.Menu.Item, {
    shouldForwardProp: (prop) => prop !== 'isPlaceholder',
})(constants_1.dropdownItemStyles);
const ItemContent = styled_1.default.div({
    alignItems: 'center',
    display: 'flex',
    gridGap: 8,
});
const DropdownItem = (props) => {
    return ((0, jsx_runtime_1.jsx)(Item, { disabled: props.disabled, isPlaceholder: !!props.placeholder, onClick: props.onClick, small: props.small, children: (0, jsx_runtime_1.jsxs)(ItemContent, { children: [props.icon === null ? ((0, jsx_runtime_1.jsx)(IconPlaceholder, {})) : (props.icon && ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { color: props.disabled ? constants_1.Color.DARK_MEDIUM_GREY : constants_1.Color.DARK_GREY, name: props.icon, size: "sm" }))), props.children] }) }));
};
exports.DropdownItem = DropdownItem;
